import type { Grade } from '@strategy4kids/lessons';
import { PartyPopper } from 'lucide-react';
import { Button } from './Button.js';
import { ProgressStars } from './ProgressStars.js';

export interface CelebrationProps {
  readonly grade: Grade;
  readonly title: string;
  readonly onNext: () => void;
}

export function Celebration({ grade, title, onNext }: CelebrationProps) {
  return (
    <div
      data-testid="celebration"
      className="fixed inset-0 z-50 flex items-center justify-center bg-ink/60 backdrop-blur-sm"
    >
      <div className="rounded-3xl border-4 border-sun bg-cream p-8 text-center shadow-2xl">
        <PartyPopper className="mx-auto text-sun" size={48} />
        <h2 className="mt-2 text-2xl font-black text-ink">Lesson complete!</h2>
        <p className="mt-1 text-lg text-ink/70">{title}</p>
        <div className="mt-4 flex justify-center">
          <ProgressStars grade={grade} size={40} />
        </div>
        <Button onClick={onNext} className="mt-6">
          Next lesson
        </Button>
      </div>
    </div>
  );
}
